export default "__VITE_ASSET__BHATUF5d__"